import {whenResize} from "@straylightagency/utils";
import {Camera, Controls, Renderer, Scene, Godray} from "./lib/stray";
import {MathUtils} from "three";

export default async (canvas, assets, debug = false) => {
    const scene = new Scene;

    const perlin = assets.texture;

    const triangles = assets.triangles.scene;
    triangles.receiveShadow = true;
    triangles.castShadow = true;
    triangles.position.set( 4, -30, -18 );
    triangles.rotation.set(
        MathUtils.degToRad( 0 ),
        MathUtils.degToRad( 39 ),
        MathUtils.degToRad( 19 )
    );

    scene.add( triangles );

    const godray1 = new Godray({
        position: [36, 4.2, -15],
        rotation: [14.76, 37.08, 333.36],
        radiusTop: 3,
        radiusBottom: 17,
        height: 100,
        radialSegments: 32,
        color: "#bcba9b",
        texture: perlin,
    } );

    scene.add( godray1 );

    const godray2 = new Godray({
        position: [-18, -10, -20],
        rotation: [0, 190, 33],
        radiusTop: 3,
        radiusBottom: 15,
        height: 142,
        radialSegments: 32,
        color: "#bcb59b",
        texture: perlin,
    } );

    scene.add( godray2 );

    scene.updateMaterials();

    let camera, renderer, width, controls;

    whenResize( ({ww, wh}) => {
        wh = window.screen.height;

        if ( camera && renderer ) {
            camera.aspect = ww / wh;
            camera.updateProjectionMatrix();
            renderer.setSize( ww, wh );
        } else {
            camera = new Camera( ww / wh, scene.position );

            renderer = new Renderer( scene, camera, canvas, {
                width: ww,
                height: wh,
            } );
        }

        width = ww;
    } );

    let targetMouseX = 0;
    let currentMouseX = 0;
    const ease = 0.25;

    if ( debug ) {
        controls = new Controls( camera, renderer.domElement );
        controls.withCameraControls();

        const folderPositionMesh = controls.folder( 'TRIANGLES.position' );
        const folderRotationMesh = controls.folder( 'TRIANGLES.rotation' );

        const position = {
            x: triangles.position.x,
            y: triangles.position.y,
            z: triangles.position.z,
        };

        const rotation = {
            x: MathUtils.radToDeg( triangles.rotation.x ),
            y: MathUtils.radToDeg( triangles.rotation.y ),
            z: MathUtils.radToDeg( triangles.rotation.z ),
        };

        function updateMesh() {
            triangles.position.set( position.x, position.y, position.z );
            triangles.rotation.set(
                MathUtils.degToRad( rotation.x ),
                MathUtils.degToRad( rotation.y ),
                MathUtils.degToRad( rotation.z )
            );
        }

        folderPositionMesh.add( position, "x", -100, 100 ).step( 1 ).listen().onChange( updateMesh );
        folderPositionMesh.add( position, "y", -100, 100 ).step( 1 ).listen().onChange( updateMesh );
        folderPositionMesh.add( position, "z", -100, 100 ).step( 1 ).listen().onChange( updateMesh );
        folderRotationMesh.add( rotation, "x", 0, 360 ).step( 1 ).listen().onChange( updateMesh );
        folderRotationMesh.add( rotation, "y", 0, 360 ).step( 1 ).listen().onChange( updateMesh );
        folderRotationMesh.add( rotation, "z", 0, 360 ).step( 1 ).listen().onChange( updateMesh );
    } else {
        window.addEventListener('mousemove', e => {
            targetMouseX = (e.clientX - ( width / 2 ) ) / 100;
        } );

        window.addEventListener('deviceorientation', e => {
            targetMouseX = (e.gamma - ( width / 2 ) ) / 10;
        } );
    }

    if ( renderer ) {
        const bgGradientEl = document.querySelector('.bg-gradient');
        const rotationSpeed = 0.5;
        let angle = 0;

        renderer.onUpdate( ({delta}) => {
            if ( controls ) {
                controls.update();
            }

            currentMouseX += (targetMouseX - currentMouseX) * ease;

            camera.position.x = (currentMouseX * 0.2) * -1;
            triangles.position.x = (currentMouseX * 0.35);

            if ( bgGradientEl ) {
                angle = (angle + rotationSpeed) % 360;
                bgGradientEl.style.setProperty('--gradient-angle', `${angle}deg`);
            }

            godray1.update( delta );
            godray2.update( delta );
        } );
    }

    return true;
};